import { render } from "./CCardImg.vue?vue&type=template&id=1aecaaab"
import script from "./CCardImg.vue?vue&type=script&lang=js"
export * from "./CCardImg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__